import { render, staticRenderFns } from "./WeekDay.vue?vue&type=template&id=106967fa&scoped=true&"
import script from "./WeekDay.vue?vue&type=script&lang=js&"
export * from "./WeekDay.vue?vue&type=script&lang=js&"
import style0 from "./WeekDay.vue?vue&type=style&index=0&id=106967fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106967fa",
  null
  
)

export default component.exports